import { Box, Paper, Skeleton } from "@mui/material"

type Props = {
  rows?: number
  tall?: boolean
}

export function ExamSectionSkeleton({ rows = 5, tall = false }: Props) {
  return (
    <Paper sx={{ p: 3 }}>
      {/* Title */}
      <Skeleton variant="text" width={260} height={28} sx={{ mb: 2 }} />

      {/* Optional tall section — mimics donut + stat cards (ExamSummarySection) */}
      {tall && (
        <Box sx={{ display: "flex", gap: 4, mb: 3 }}>
          <Skeleton variant="circular" width={220} height={220} />
          <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
            <Skeleton variant="rectangular" width={80} height={60} />
            <Skeleton variant="rectangular" width={80} height={60} />
            <Skeleton variant="rectangular" width={80} height={60} />
          </Box>
        </Box>
      )}

      {/* Table header */}
      <Skeleton variant="rectangular" width="100%" height={36} sx={{ mb: 1 }} />

      {/* Table rows */}
      {Array.from({ length: rows }, (_, i) => `skeleton-row-${i}`).map((key) => (
        <Skeleton key={key} variant="rectangular" width="100%" height={32} sx={{ mb: 0.5 }} />
      ))}
    </Paper>
  )
}
